export type LatLng = { lat: number; lng: number }

const R = 6371000
const rad = (d: number) => (d * Math.PI) / 180

/** Distância em metros entre dois pontos (fórmula de haversine, raio médio da Terra). */
export function haversineMeters(a: LatLng, b: LatLng): number {
  const dLat = rad(b.lat - a.lat)
  const dLng = rad(b.lng - a.lng)
  const h =
    Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2
  return 2 * R * Math.asin(Math.sqrt(h))
}

/** Formata distância em pt-BR: `521 m`, `1,9 km`, `—` quando não há valor. */
export function formatMeters(m: number | null | undefined): string {
  if (m == null || !Number.isFinite(m)) return '—'
  if (m < 999.5) return `${Math.round(m)} m`
  return `${(m / 1000).toFixed(1).replace('.', ',')} km`
}

const POINTS = ['norte', 'nordeste', 'leste', 'sudeste', 'sul', 'sudoeste', 'oeste', 'noroeste']

/** Rumo de `from` para `to` em um dos 8 pontos cardeais/colaterais. */
export function bearingLabel(from: LatLng, to: LatLng): string {
  const y = Math.sin(rad(to.lng - from.lng)) * Math.cos(rad(to.lat))
  const x =
    Math.cos(rad(from.lat)) * Math.sin(rad(to.lat)) -
    Math.sin(rad(from.lat)) * Math.cos(rad(to.lat)) * Math.cos(rad(to.lng - from.lng))
  const deg = ((Math.atan2(y, x) * 180) / Math.PI + 360) % 360
  return POINTS[Math.round(deg / 45) % 8]
}
